<template>
  <div class="wrap">
    <user-token-site-info :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="header-individual short" :class="header_notification ? 'header-notification-space' : ''">
      <router-link to="/report">
        <div class="pointer" style="font-size: 11px; color: #666"><font-awesome-icon :icon="['fas', 'arrow-left']" style="margin-right: 5px" />レポート一覧に戻る</div>
      </router-link>
    </div>

    <!-- ユーザーページ -->
    <div class="list-detail-page-wrap">
      <div v-if="report_id == 'demo' && demo_notification" class="demo-report-wrap">
        <div class="demo-report-notification">
          この画面では架空のデモレポートを表示しています。デモレポートは内容の変更は行えません。
          <div class="flex-space"></div>
          <font-awesome-icon :icon="['fal', 'times']" style="cursor: pointer; padding: 5px 10px" @click="demo_notification = false" />
        </div>
      </div>
      <div class="list-breadcrumb-wrap report">
        <div class="list-summary max-width" :class="loading ? 'transparent' : ''">
          <div class="list-breadcrumb-image" @click="img_change = true">
            <div class="list-breadcrumb-icon">
              <font-awesome-icon :icon="['fas', 'camera-alt']" />
            </div>
            <el-image :src="report.summary.img_url" class="data-table-profile list_img" fit="cover">
              <div slot="error" class="data-table-list-noimg">
                <font-awesome-icon :icon="['far', 'chart-bar']" />
              </div>
            </el-image>
          </div>
          <div class="list-breacrumb-namearea" v-if="!loading">
            <div class="list-breadcrumb-name">
              <div>{{ loading ? "" : report.summary.report_name }}</div>
              <el-tooltip>
                <div slot="content">レポート名を変更</div>
                <i class="el-icon-edit pointer" style="color: #aaa; font-size: 14px; margin-left: 10px" @click="report_id == 'demo' ? '' : openChangeReport()"></i>
              </el-tooltip>
            </div>
            <div class="list-breadcrumb-description flex-wrap">
              <span v-if="report.summary.report_type == 'manual'" style="color: #666; margin-right: 5px"
              ><font-awesome-icon :icon="['fal', 'file-csv']" style="margin-right: 3px;" /> Excelよりインポート&nbsp;・</span
              >
              <span v-if="report.summary.report_type != 'manual'" style="color: #666; margin-right: 5px">トラッキングタグ:</span>
              <span v-if="report.summary.trackingtag == 'off'" style="margin-right:10px;">設定しない&nbsp;</span>
              <span v-else-if="report.summary.mentiontag">
                <span v-for="mentiontag in report.summary.mentiontag" :key="mentiontag.id">{{ mentiontag }}&nbsp;</span>・
              </span>
              <span v-if="report.summary.hashtag">
                <span v-for="hashtag in report.summary.hashtag" :key="hashtag.id">{{ hashtag }}&nbsp;</span>・
              </span>
              <span v-if="report.summary.keyword && report.summary.keyword != null">
                <span>{{ report.summary.keyword.join(', ') }}&nbsp;</span>
              </span>
              <span v-if="report.summary.report_type != 'manual'" style="color: #666; margin-right: 5px">トラッキング期間:</span>
              <span v-else style="color: #666; margin-right: 5px">データ集計期間:</span>
              <span>
                {{ report.summary.start_at | date }}~
                <span v-if="report.summary.end_at">{{ report.summary.end_at | date }}</span>
                <span v-else></span>
                ・</span
              >
              &nbsp;{{ report.summary.created_at | lastUpadate }}に作成
            </div>
          </div>
        </div>
        <div class="list-detail-menu-wrap right-auto">
          <div class="list-detail-menu">
            <el-button :disabled="loading" type="info" @click="settingOpen()" v-if="report.summary.report_type != 'manual'">
              <font-awesome-icon :icon="['fas', 'cog']" />
            </el-button>
            <el-tooltip placement="top" :disabled="export_report_enabled">
              <div class="activate-popover" slot="content">
                <div class="pointer" @click="toSetting">アップグレード</div>
                でご利用いただけます
              </div>
              <span style="margin-left: 10px;">
                <el-button type="info" :disabled="loading || !export_report_enabled" @click="exportReportDetail()">
                  <font-awesome-icon :icon="['fas', 'cloud-download']" style="margin-right:5px" />エクスポート
                </el-button>
              </span>
            </el-tooltip>
            <el-dropdown trigger="click" placement="bottom-start" style="margin-left:10px">
              <el-button :disabled="loading" type="primary" icon="el-icon-plus" style="margin-right: 10px">追加</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="addMedia()"> <font-awesome-icon :icon="['fab', 'instagram']" style="margin-right: 5px" />投稿を追加（Instagram） </el-dropdown-item>
                <el-dropdown-item @click.native="addMediaTikTok()"> <font-awesome-icon :icon="['fab', 'tiktok']" style="margin-right: 5px" />投稿を追加（TikTok） </el-dropdown-item>
                <el-dropdown-item @click.native="addMediaX()">
                  <span class="flex-row" style="align-items:center">
                    <svg width="12" height="12" viewBox="0 0 1200 1227" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style="margin-right:5px">
                      <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
                    </svg>
                    投稿を追加（X）
                  </span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="add_influencer_modal = true" :disabled="report.summary.report_type == 'manual'">
                  <font-awesome-icon :icon="['fal', 'user']" style="margin-right: 5px" />インフルエンサーを追加
                </el-dropdown-item>
                <el-dropdown-item @click.native="add_csv_modal = true" :disabled="report.summary.report_type != 'manual'">
                  <font-awesome-icon :icon="['fal', 'file-csv']" style="margin-right: 5px" />Excel/CSVから追加
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button @click="refreshReport(true)">
              <font-awesome-icon :icon="['far', 'sync-alt']" />
            </el-button>
          </div>
        </div>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="tabClick()" class="tab-report">
          <el-tab-pane label="サマリー（Instagram）" name="summary">
            <reportSummary
                :summary="report.summary"
                :loading="loading"
                :report_id="report_id"
                :done_data="done_data"
                :doughnut_data="doughnut_data"
                :graph_data="graph_data"
                :reRender="reRender"
            />
          </el-tab-pane>

          <!-- 投稿一覧（Instagram） -->
          <el-tab-pane name="media">
            <span slot="label">
              投稿一覧（Instagram）
              <span class="tab-badges" v-if="!loading">
                <span class="tab-badge b-post">{{ instagramPostCount | addComma }}</span>
              </span>
            </span>
            <div class="report-tab-count-wrap">
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'images']" class="report-tab-count-icon" />{{ instagramPostCount | addComma }}件</span>
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'user']" class="report-tab-count-icon" />{{ instagramInfluencerCount | addComma }}人</span>
            </div>
            <reportPostList ref="reportPostList" :report_id="report_id" :sns_type="'instagram'" v-if="activeName == 'media'" @openInfluencer="openInfluencer" @loadReportDetail="loadReportDetail" />
          </el-tab-pane>
          <!-- インフルエンサー（Instagram） -->
          <el-tab-pane name="influencer" class="influencer_list">
            <span slot="label">
              インフルエンサー（Instagram）
              <span class="tab-badges" v-if="!loading">
                <span class="tab-badge b-inf">{{ instagramInfluencerCount | addComma }}</span>
              </span>
            </span>
            <div class="report-tab-count-wrap">
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'user']" class="report-tab-count-icon" />{{ instagramInfluencerCount | addComma }}人</span>
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'images']" class="report-tab-count-icon" />{{ instagramPostCount | addComma }}件</span>
            </div>
            <reportInfluencer ref="reportInfluencer" :report_id="report_id" :sns_type="'instagram'" v-if="activeName == 'influencer'" @openInfluencer="openInfluencer" @loadReportDetail="loadReportDetail" />
          </el-tab-pane>
          <!-- 投稿一覧（TikTok） -->
          <el-tab-pane name="media_tiktok">
            <span slot="label">
              投稿一覧（TikTok）
              <span class="tab-badges" v-if="!loading">
                <span class="tab-badge b-post">{{ tiktokPostCount | addComma }}</span>
              </span>
            </span>
            <div class="report-tab-count-wrap">
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'images']" class="report-tab-count-icon" />{{ tiktokPostCount | addComma }}件</span>
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'user']" class="report-tab-count-icon" />{{ tiktokInfluencerCount | addComma }}人</span>
            </div>
            <reportPostListTiktok
                ref="reportPostListTiktok"
                :report_id="report_id"
                :sns_type="'tiktok'"
                v-if="activeName == 'media_tiktok'"
                @openInfluencer="openInfluencer"
                @loadReportDetail="loadReportDetail"
            />
          </el-tab-pane>
          <!-- インフルエンサー（TikTok） -->
          <el-tab-pane name="influencer_tiktok" class="influencer_list">
            <span slot="label">
              インフルエンサー（TikTok）
              <span class="tab-badges" v-if="!loading">
                <span class="tab-badge b-inf">{{ tiktokInfluencerCount | addComma }}</span>
              </span>
            </span>
            <div class="report-tab-count-wrap">
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'user']" class="report-tab-count-icon" />{{ tiktokInfluencerCount | addComma }}人</span>
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'images']" class="report-tab-count-icon" />{{ tiktokPostCount | addComma }}件</span>
            </div>
            <reportInfluencer ref="reportInfluencerTiktok" :report_id="report_id" :sns_type="'tiktok'" v-if="activeName == 'influencer_tiktok'" @openInfluencer="openInfluencer" @loadReportDetail="loadReportDetail" />
          </el-tab-pane>
          <!-- 投稿一覧（X） -->
          <el-tab-pane name="media_x">
            <span slot="label">
              投稿一覧（X）
              <span class="tab-badges" v-if="!loading">
                <span class="tab-badge b-post">{{ xPostCount | addComma }}</span>
              </span>
            </span>
            <div class="report-tab-count-wrap">
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'images']" class="report-tab-count-icon" />{{ xPostCount | addComma }}件</span>
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'user']" class="report-tab-count-icon" />{{ xInfluencerCount | addComma }}人</span>
            </div>
            <reportPostListX
                ref="reportPostListX"
                :report_id="report_id"
                :sns_type="'x'"
                v-if="activeName == 'media_x'"
                @openInfluencer="openInfluencer"
                @loadReportDetail="loadReportDetail"
            />
          </el-tab-pane>
          <!-- インフルエンサー（X） -->
          <el-tab-pane name="influencer_x" class="influencer_list">
            <span slot="label">
              インフルエンサー（X）
              <span class="tab-badges" v-if="!loading">
                <span class="tab-badge b-inf">{{ xInfluencerCount | addComma }}</span>
              </span>
            </span>
            <div class="report-tab-count-wrap">
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'user']" class="report-tab-count-icon" />{{ xInfluencerCount | addComma }}人</span>
              <span class="report-tab-count-item"><font-awesome-icon :icon="['fal', 'images']" class="report-tab-count-icon" />{{ xPostCount | addComma }}件</span>
            </div>
            <reportInfluencer ref="reportInfluencerX" :report_id="report_id" :sns_type="'x'" v-if="activeName == 'influencer_x'" @openInfluencer="openInfluencer" @loadReportDetail="loadReportDetail" />
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- drawer -->
      <div :class="[influencer_drawer ? 'i-detail-modal open' : 'i-detail-modal']" style="z-index: 1005" id="i-detail-scroll">
<!--        <router-view ref="iDetail" v-show="influencer_drawer" :key="$route.fullPath"></router-view>-->
        <router-view
            ref="iDetail"
            v-if="influencer_drawer && !detailLoading"
            :key="influencer_view_key"
        />
      </div>
      <div :class="[influencer_drawer ? 'overlay-b open' : 'overlay-b']" @click="closeInfluencer" style="z-index: 1004"></div>

      <!-- imgChange -->
      <el-dialog title="レポートイメージ画像の変更" :visible.sync="img_change" width="420px" top="20vh">
        <el-upload drag :on-change="imgAdd" :auto-upload="false" list-type="picture" limit="1" :file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            画像をドロップ
            <em>もしくは選択してアップロードしてください</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            推奨ファイル:500kb以下のjpg/png形式
          </div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="(img_change = false), (fileList = [])">キャンセル</el-button>
          <el-button :disabled="report_id == 'demo'" type="primary" @click="report_id == 'demo' ? '' : imgUpload()">変更</el-button>
        </span>
      </el-dialog>

      <!-- インフルエンサー追加 -->
      <div :class="[add_influencer_modal ? 'overlay open' : 'overlay']" @click="add_influencer_modal = false"></div>
      <div :class="[add_influencer_modal && setting_modal ? 'pr-detail-modal wide-open' : add_influencer_modal ? 'pr-detail-modal open' : 'pr-detail-modal']">
        <div class="request-pr-wrap" v-if="add_influencer_modal">
          <div class="request-pr-title" style="font-size: 16px">
            インフルエンサーの追加
          </div>
          <div class="request-pr-form">
            <div class="request-pr-form-wrap">
              <div class="request-pr-form-title">
                レポート測定したいインフルエンサーを選択してください
              </div>
              <div class="request-pr-form-parts" style="flex-flow: column" v-if="report.summary.report_type != 'manual'">
                <span>追加したインフルエンサーの投稿のうち、トラッキングタグを含む投稿を自動で取得・トラッキングします。</span>
              </div>
              <div v-if="report.summary.report_type != 'manual'" class="report-detail-subtitle">トラッキングタグ:</div>
              <div v-if="report.summary.report_type != 'manual'" class="request-pr-form-parts" style="flex-flow: column">
                <div class="report-detail-trackingtag" @click="settingOpen()" @mouseover="trackingtag_on = true" @mouseleave="trackingtag_on = false">
                  <span v-for="hashtag in report.summary.hashtag" :key="hashtag.id">{{ hashtag }},</span>
                  <span v-for="mentiontag in report.summary.mentiontag" :key="mentiontag.id">{{ mentiontag }},</span>
                  <span v-for="keyword in report.summary.keyword" :key="keyword.id">{{ keyword }}</span>
                  <span v-if="report.summary.mentiontag == '' && report.summary.hashtag == '' && report.summary.keyword == ''">
                    <font-awesome-icon :icon="['fal', 'exclamation-circle']" style="margin-right: 5px" />トラッキングタグが設定されていません
                  </span>
                  <div class="flex-space"></div>
                  <transition name="fade">
                    <font-awesome-icon :icon="['far', 'chevron-right']" style="margin-right: 5px" v-show="trackingtag_on" />
                  </transition>
                </div>
              </div>
              
              <influencerSuggest
                  @syncInfluencerList="syncInfluencerList('instagram', $event)"
                  :referer="'report'"
                  :sns_type="'instagram'"
                  :influencer_list.sync="report.instagram.influencer_list"
                  :report_switch.sync="report.instagram.report_switch"
                  :checkList.sync="report.instagram.checkList"
                  :allCheckLists="allCheckLists"
              />

              <hr class="sns-divider" />

              <influencerSuggest
                  @syncInfluencerList="syncInfluencerList('tiktok', $event)"
                  :referer="'report'"
                  :sns_type="'tiktok'"
                  :influencer_list.sync="report.tiktok.influencer_list"
                  :report_switch.sync="report.tiktok.report_switch"
                  :checkList.sync="report.tiktok.checkList"
                  :allCheckLists="allCheckLists"
              />

              <hr class="sns-divider" />

              <influencerSuggest
                  @syncInfluencerList="syncInfluencerList('twitter', $event)"
                  :referer="'report'"
                  :sns_type="'twitter'"
                  :influencer_list.sync="report.twitter.influencer_list"
                  :report_switch.sync="report.twitter.report_switch"
                  :checkList.sync="report.twitter.checkList"
                  :allCheckLists="allCheckLists"
              />

            </div>
            <div class="request-pr-form-buttonarea">
              <div class="report-detail-noinfluencer">
                追加したいインフルエンサーが登録されていない場合は
                <router-link to="/request" target="_blank">
                  <span class="router-link"
                  >こちら
                    <font-awesome-icon :icon="['far', 'external-link']" style="margin-right: 3px;" />
                  </span>
                </router-link>
                からリクエストできます
              </div>
              <div class="flex-space"></div>
              <el-button @click="report_id == 'demo' ? '' : addInfluencer()" type="primary" :disabled="add_loading || report_id == 'demo'">
                <div class="flex-row">
                  インフルエンサーを追加
                  <div class="loader--mini" v-show="add_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- ハッシュタグ・メンションタグ設定 -->
      <div class="overlay" :class="[setting_modal ? 'overlay open' : 'overlay']" @click="settingClose()" style="z-index: 1002"></div>
      <div :class="[setting_modal ? 'pr-detail-modal open' : 'pr-detail-modal']" style="z-index: 1003">
        <div class="request-pr-wrap" v-if="setting_modal">
          <div class="request-pr-title" style="font-size: 16px">
            レポート設定
          </div>
          <div class="request-pr-form">
            <div class="request-pr-form-wrap">
              <div class="request-pr-form-title">トラッキングタグ</div>
              <div class="request-pr-form-parts" style="margin-bottom: 20px">
                <ul class="request-pr-form-description">
                  <li>設定したトラッキング期間中、レポートにアサインされたインフルエンサーの投稿のうち、指定のハッシュタグもしくはメンションタグ、キーワードを含む投稿を自動で取得します。</li>
                  <li>ハッシュタグでトラッキングする場合は、ブランド名やキャンペーン名を含むようなユニークなハッシュタグを設定してください。</li>
                  <li style="margin-bottom:0">トラッキングタグが設定されていない場合は、トラッキング期間中の全ての投稿を取得します。</li>
                </ul>
              </div>
              <div class="request-pr-form-parts">
                <div class="request-pr-form-subtitle">
                  トラッキングタグ
                </div>
                <div class="request-pr-form-hashtag">
                  <div class="request-pr-form-hashtag-input" style="margin-top:10px">
                    <el-radio v-model="report.summary.trackingtag" label="on" disabled style="margin-right: 20px;">設定する</el-radio>
                    <el-radio v-model="report.summary.trackingtag" label="off" disabled>設定しない(トラッキング期間の全投稿を取得)</el-radio>
                  </div>
                </div>
              </div>
              <div class="request-pr-form-parts" v-if="report.summary.trackingtag == 'on'">
                <div class="request-pr-form-subtitle">
                  ハッシュタグ(最大3つ)
                </div>
                <div class="request-pr-form-hashtag">
                  <div class="request-pr-form-hashtag-input">
                    <el-input
                        @keyup.enter.native="addHashtag()"
                        @blur="enter_on ? '' : addHashtag()"
                        v-model="edit.hashtagValue"
                        placeholder="ハッシュタグを入力(Enterで追加)"
                        :disabled="report_id == 'demo'"
                    >
                      <template slot="prepend">
                        <font-awesome-icon :icon="['fal', 'hashtag']" />
                      </template>
                    </el-input>
                    <div class="request-pr-form-hashtag-num">{{ edit.hashtag.length }}/3</div>
                  </div>
                  <div class="request-pr-form-hashtag-wrap">
                    <div class="request-pr-form-hashtagbox" v-for="hashtag in edit.hashtag" :key="hashtag.id">
                      {{ hashtag }}
                      <div :key="hashtag" @click="deleteHashtag(hashtag)">
                        <font-awesome-icon
                            :icon="['fas', 'times']"
                            style="
                            cursor: pointer;
                            margin-left: 10px;
                            font-size: 14px;
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="request-pr-form-parts" v-if="report.summary.trackingtag == 'on'">
                <div class="request-pr-form-subtitle">メンションタグ</div>
                <mentiontagSuggest :create="true" :report_id="'demo'" @syncMentiontag="syncMentiontag" v-if="report.summary.mentiontag == ''" />
                <div class="request-pr-form-hashtag" v-else>
                  <el-tooltip placement="top-start">
                    <div slot="content">メンションタグは変更できません</div>
                    <div class="request-pr-form-hashtag-wrap">
                      <div class="request-pr-form-add-box mention">
                        <div>
                          <div>{{ report.summary.mentiontag[0] }}</div>
                        </div>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <div class="request-pr-form-parts" v-if="report.summary.trackingtag == 'on'">
                <div class="request-pr-form-subtitle">
                  キーワード(最大3つ)
                </div>
                <div class="request-pr-form-hashtag">
                  <div class="request-pr-form-hashtag-input">
                    <el-input
                        @keyup.enter.native="addKeyword()"
                        @blur="enter_on ? '' : addKeyword()"
                        v-model="edit.keywordValue"
                        placeholder="キーワードを入力(Enterで追加)"
                        :disabled="report_id == 'demo'"
                    >
                      <template slot="prepend">
                      </template>
                    </el-input>
                    <div class="request-pr-form-hashtag-num">{{ edit.keyword.length }}/3</div>
                  </div>
                  <div class="request-pr-form-hashtag-wrap">
                    <div class="request-pr-form-hashtagbox" v-for="keyword in edit.keyword" :key="keyword.id">
                      {{ keyword }}
                      <div :key="keyword" @click="deleteKeyword(keyword)">
                        <font-awesome-icon
                            :icon="['fas', 'times']"
                            style="
                            cursor: pointer;
                            margin-left: 10px;
                            font-size: 14px;
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="request-pr-form-parts">
                <div class="request-pr-form-subtitle">
                  トラッキング期間
                  <el-tooltip>
                    <div slot="content">
                      最大2ヶ月間自動でトラッキングを行います
                    </div>
                    <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 3px; color: #aaa" />
                  </el-tooltip>
                </div>
                <el-tooltip placement="top-start">
                  <div slot="content">トラッキング期間は変更できません</div>
                  <span>
                    <div class="report-date-row">
                      <el-date-picker
                          v-model="report.summary.start_at"
                          type="date"
                          placeholder="トラッキング開始日を選択してください"
                          format="yyyy/MM/dd"
                          value-format="yyyy-MM-dd"
                          style="width: 50%"
                          disabled
                      ></el-date-picker>
                      <div class="report-date-space">〜</div>
                      <el-date-picker v-model="end_at" disabled type="date" placeholder="自動選択されます" format="yyyy/MM/dd" value-format="yyyy/M/dd" style="width: 50%"></el-date-picker>
                    </div>
                  </span>
                </el-tooltip>
              </div>
            </div>
            <div class="request-pr-form-buttonarea">
              <el-button @click="changeReportSetting()" type="primary" :disabled="setting_loading || change_flag == 0 || report_id == 'demo' || report.summary.trackingtag == 'off'">
                <div class="flex-row">
                  設定を保存
                  <div class="loader--mini" v-show="setting_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <createList
        :create_list.sync="change_report"
        :type="'change_report'"
        :target_list_name="report.summary.report_name"
        :target_list_id="report.summary.report_id"
        @changeReportName="changeReportName"
    />

    <export-dialog :export_dialog.sync="export_dialog" :report_id="report_id" />

    <reportAddDrawer :add_csv_modal.sync="add_csv_modal" :report_id="report_id" @loadReport="loadReportDetail" @closeCreateReport="add_csv_modal = false" />
  </div>
</template>

<script>
import reportSummary from "./report_summary";
import mentiontagSuggest from "./mentiontag_suggest";
import influencerSuggest from "./influencer_suggest";
import createList from "../list/createList";
import reportPostList from "./report_post_list";
import reportInfluencer from "./report_influencer";
import exportDialog from "./report_export_dialog.vue";
import reportAddDrawer from "./report_add_drawer.vue";
import UserTokenSiteInfo from "@/components/oem/UserTokenSiteInfo.vue";
const root = process.env.VUE_APP_API;
const loadReportDetailAPI = root + "/api/report/load_reportdetail";
const addMediaAPI = root + "/api/report/add_media";
const addInfluencerAPI = root + "/api/report/add_influencer";
const refreshReportAPI = root + "/api/report/refresh";
const changeReportSettingAPI = root + "/api/report/change_report_setting";
const ImgUploadAPI = root + "/api/list/img_upload";
// import reportPostValueX from "./report_post_value_x.vue";
import reportPostListX from "./report_post_list_x.vue";
// import reportPostValueTiktok from "./report_post_value_tiktok.vue";
import reportPostListTiktok from "./report_post_list_tiktok.vue";

export default {
  name: "reportDetail",
  components: {
    UserTokenSiteInfo,
    reportSummary,
    mentiontagSuggest,
    influencerSuggest,
    createList,
    reportPostList,
    reportInfluencer,
    exportDialog,
    reportAddDrawer,
    reportPostListTiktok,
    reportPostListX,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      influencer_view_key: "",
      openSeq: 0,
      detailLoading: false,
      activeName: "summary",
      report_id: "",
      report: {
        summary: {},
        post: [],
        influencer: [],
        instagram: {
          influencer_list: [],
          report_switch: "left",
          checkList: [],
        },
        tiktok: {
          influencer_list: [],
          report_switch: "left",
          checkList: [],
        },
        twitter: {
          influencer_list: [],
          report_switch: "left",
          checkList: [],
        },
      },
      edit: {
        report_name: "",
        mentiontag: [],
        mentiontagValue: "",
        hashtag: [],
        hashtagValue: "",
        keyword: [],
        keywordValue: "",
      },
      done_data: true,
      trackingtag_on: false,
      change_flag: 0,
      loading: true,
      enter_on: false,
      mouseover: -1,
      img_change: false,
      file: "",
      fileList: [],
      account_name: "",
      checkList: [],
      checkListDetail: [],
      checkAll_val: false,
      checkedCount: 0,
      drawer: false,
      influencer_drawer: false,
      search_influencer: "",
      search_influencer_regexp: "",
      max_width: "100%",
      add_loading: false,
      setting_modal: false,
      setting_loading: false,
      graph_data: {},
      graphdetail_data: {},
      doughnut_data: [],
      reRender: 0,
      demo_notification: true,
      count: 0,
      result_count: 0,
      requestId: 0,
      change_report: false,
      add_influencer_modal: false,
      add_csv_modal: false,
      export_dialog: false,
      siteName: "REECH DATABASE",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    openMenu() {
      return this.$store.state.openMenu;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    export_report_enabled() {
      return !!this.$store.state.service_plan.export_report_enabled;
    },
    oneMonthLater() {
      var start = this.report.summary.start_at;
      if (start) {
        var startArray = start.split("-");
        var year = startArray[0];
        var month = Number(startArray[1]) + 1;
        var day = startArray[2];
        return year + "/" + month + "/" + day;
      } else {
        return "";
      }
    },
    end_at() {
      if (this.report.summary.end_at) {
        return this.report.summary.end_at;
      } else {
        return this.oneMonthLater;
      }
    },
    instagramPostCount() {
      return this.report.summary.instagram_post_num || this.report.summary.post_num || 0;
    },
    instagramInfluencerCount() {
      return this.report.summary.instagram_influencer_num || this.report.summary.influencer_num || this.report.summary.influencer_num_done || 0;
    },
    tiktokPostCount() {
      return this.report.summary.tiktok_post_num || 0;
    },
    tiktokInfluencerCount() {
      return this.report.summary.tiktok_influencer_num || 0;
    },
    xPostCount() {
      return this.report.summary.twitter_post_num || 0;
    },
    xInfluencerCount() {
      return this.report.summary.twitter_influencer_num || 0;
    },
  },
  created() {},
  mounted() {
    this.loadQuery();
    this.loadReportDetail();
  },
  methods: {
    loadReportBadges() {
      const loadReportBadgesAPI = root + "/api/report/load_report_badges";
      this.axios.get(loadReportBadgesAPI, {
        params: { report_id: this.report_id, token: this.token },
      }).then((res) => {
        if (res.data.status === "OK") {
          // summary内のカウント用プロパティのみをマージ
          this.report.summary = { ...this.report.summary, ...res.data.counts };
        }
      });
    },
    loadReportDetail() {
      this.axios
          .get(loadReportDetailAPI, {
            params: {
              report_id: this.report_id == "demo" ? 1 : this.report_id,
              token: this.report_id == "demo" ? "demo" : this.token,
            },
          })
          .then((response) => {
            if (response.data.status == "OK") {
              this.report.sns_type = response.data.summary.sns_type;
              this.report.summary = response.data.summary;
              this.doughnut_data = response.data.doughnut_data;
              this.graph_data = response.data.graph_data;
              this.loading = false;
              if (this.report_id == "demo" || this.report.summary.influencer_num_done == 0) this.done_data = false;
            } else {
              this.$router.push("/404");
            }
          });
    },
    tabClick() {
      this.reRender += 1;
      this.count = 0;
      if (this.activeName === "summary") {
        this.loadReportDetail();
      } else {
        // タブ切り替え時にバッジ数値をリフレッシュ
        this.loadReportBadges();
      }
    },
    attachPromptValidation(pattern, customClass) {
      const tryAttach = (attempt = 0) => {
        const prompt = document.querySelector(`.${customClass}`);
        if (!prompt) {
          if (attempt < 10) setTimeout(() => tryAttach(attempt + 1), 50);
          return;
        }
        const input = prompt.querySelector("input");
        const confirmButton = prompt.querySelector(".el-message-box__btns .el-button--primary");
        if (!input || !confirmButton) return;

        const updateState = () => {
          const value = input.value || "";
          const isValid = pattern.test(value);
          confirmButton.disabled = !isValid;
          confirmButton.style.pointerEvents = isValid ? "" : "none";
          confirmButton.style.opacity = isValid ? "" : "0.5";
        };

        updateState();
        input.addEventListener("input", updateState);
      };

      tryAttach();
    },
    getPromptResetBeforeClose() {
      return (action, instance, done) => {
        const confirmButton = instance.$el.querySelector(".el-message-box__btns .el-button--primary");
        if (confirmButton) {
          confirmButton.disabled = false;
          confirmButton.style.pointerEvents = "";
          confirmButton.style.opacity = "";
        }
        done();
      };
    },
    reloadActiveTabLists() {
      if (this.activeName === "media") this.$refs.reportPostList?.reload?.();
      if (this.activeName === "influencer") this.$refs.reportInfluencer?.reload?.();
      if (this.activeName === "media_tiktok") this.$refs.reportPostListTiktok?.reload?.();
      if (this.activeName === "influencer_tiktok") this.$refs.reportInfluencerTiktok?.reload?.();
      if (this.activeName === "media_x") this.$refs.reportPostListX?.reload?.();
      if (this.activeName === "influencer_x") this.$refs.reportInfluencerX?.reload?.();
    },
    addMedia() {
      const instagramPattern = /instagram\.com\/(p|reel)\/[^/?#]+/;
      const promptClass = "report-add-media-instagram";
      this.$prompt("追加したい投稿のURLを入力してください", "投稿の追加（Instagram）", {
        showConfirmButton: this.report_id == "demo" ? "" : true,
        confirmButtonText: "追加",
        cancelButtonText: "キャンセル",
        inputPattern: instagramPattern,
        inputValue: "",
        inputErrorMessage: "正しいURLを入力してください",
        customClass: promptClass,
        beforeClose: this.getPromptResetBeforeClose(),
      }).then(({ value }) => {
        this.$message({
          type: "info",
          offset: 7,
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message: 'レポートに投稿を追加中です<div class="loader--mini"></div>',
        });
        var params = new URLSearchParams();
        params.append("media_url", value);
        params.append("sns_type", "instagram");
        params.append("report_id", this.report_id);
        params.append("token", this.token);
        this.axios
            .post(addMediaAPI, params)
            .then((response) => {
              this.$message.closeAll();
              if (response.data.status === "OK") {
                this.reloadActiveTabLists();
                this.loadReportDetail();
                this.$alert("レポートの更新に1~2分程度時間がかかる場合があります。", "投稿を追加しました", {
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "success",
                });
              } else if (response.data.status == "NG") {
                this.$alert(`投稿データが${this.siteName} 上に存在しないため、レポートに追加できませんでした。`, "投稿データが取得できませんでした", {
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "error",
                });
              }
            })
            .catch(() => {
              this.$message.closeAll();
              this.$alert("時間を空けて再度お試しください。", "投稿の追加に失敗しました", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "error",
              });
            });
      });
      this.attachPromptValidation(instagramPattern, promptClass);
    },
    addInfluencer() {
      const igList = this.report.instagram?.influencer_list || [];
      const ttList = this.report.tiktok?.influencer_list || [];
      const xList  = this.report.twitter?.influencer_list || [];

      if (igList.length === 0 && ttList.length === 0 && xList.length === 0) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "インフルエンサーが選択されていません",
        });
        return;
      }

      this.add_loading = true;

      const params = new URLSearchParams();
      params.append("report_id", this.report_id);
      params.append("sns_type", this.report.sns_type);
      params.append("influencer", JSON.stringify(igList));
      params.append("influencer_tiktok", JSON.stringify(ttList));
      params.append("influencer_x", JSON.stringify(xList));
      params.append("user_token", this.user_token);
      params.append("token", this.token);
      this.axios
          .post(addInfluencerAPI, params)
          .then((response) => {
            this.add_loading = false;

            if (response?.data?.status && response.data.status !== "OK") {
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: response.data.message || "インフルエンサーの追加に失敗しました",
              });
              return;
            }

            // モーダル閉じ・選択状態のクリア
            this.add_influencer_modal = false;
            this.report.instagram.influencer_list = [];
            this.report.tiktok.influencer_list = [];
            this.report.twitter.influencer_list = [];
            this.report.instagram.checkList = [];
            this.report.tiktok.checkList = [];
            this.report.twitter.checkList = [];
            this.$router.push("/report");
            this.$alert("レポートの更新に1~2分程度時間がかかる場合があります。", "インフルエンサーを追加しました", {
              confirmButtonText: "OK",
              showCancelButton: false,
              type: "success",
            });
          })
          .catch(() => {
            this.add_loading = false;
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: "インフルエンサーの追加に失敗しました",
            });
            this.$store.dispatch("loadSidemenuOption", this.token);
          });
    },
    refreshReport(show) {
      var params = new URLSearchParams();
      params.append("report_id", this.report_id);
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      this.axios.post(refreshReportAPI, params).then(() => {
        this.reloadActiveTabLists();
        this.loadReportDetail();
        if (show == true) {
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "レポートを更新しました",
          });          
        }
      });
    },
    addMediaTikTok() {
      const tiktokPattern = /tiktok\.com\/@[^/]+\/video\/\d+/i;
      const promptClass = "report-add-media-tiktok";
      this.$prompt("追加したい投稿のURLを入力してください", "投稿の追加（TikTok）", {
        showConfirmButton: this.report_id == "demo" ? "" : true,
        confirmButtonText: "追加",
        cancelButtonText: "キャンセル",
        inputPattern: tiktokPattern,
        inputPlaceholder: "https://www.tiktok.com/@account_name/video/1234567890",
        inputValue: "",
        inputErrorMessage: "正しいURLを入力してください",
        customClass: promptClass,
        beforeClose: this.getPromptResetBeforeClose(),
      }).then(({ value }) => {
        this.$message({
          type: "info",
          offset: 7,
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message: 'レポートに投稿を追加中です<div class="loader--mini"></div>',
        });
        var params = new URLSearchParams();
        params.append("media_url", value);
        params.append("sns_type", "tiktok");
        params.append("report_id", this.report_id);
        params.append("token", this.token);
        this.axios
          .post(addMediaAPI, params)
          .then((response) => {
            this.$message.closeAll();
            if (response.data.status === "OK") {
              this.reloadActiveTabLists();
              this.loadReportDetail();
              this.$alert("レポートの更新に1~2分程度時間がかかる場合があります。", "投稿を追加しました", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              });
            } else if (response.data.status == "NG") {
              this.$alert(`投稿データが${this.siteName} 上に存在しないため、レポートに追加できませんでした。`, "投稿データが取得できませんでした", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "error",
              });
            }
          })
          .catch(() => {
            this.$message.closeAll();
            this.$alert("時間を空けて再度お試しください。", "投稿の追加に失敗しました", {
              confirmButtonText: "OK",
              showCancelButton: false,
              type: "error",
            });
          });
      });
      this.attachPromptValidation(tiktokPattern, promptClass);
    },
    addMediaX() {
      const xPattern = /(x|twitter)\.com\/[^/]+\/status\/\d+/i;
      const promptClass = "report-add-media-x";
      this.$prompt("追加したい投稿のURLを入力してください", "投稿の追加（X）", {
        showConfirmButton: this.report_id == "demo" ? "" : true,
        confirmButtonText: "追加",
        cancelButtonText: "キャンセル",
        inputPattern: xPattern,
        inputPlaceholder: "https://x.com/account_name/status/1234567890987654321",
        inputValue: "",
        inputErrorMessage: "正しいURLを入力してください",
        customClass: promptClass,
        beforeClose: this.getPromptResetBeforeClose(),
      }).then(({ value }) => {
        this.$message({
          type: "info",
          offset: 7,
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message: 'レポートに投稿を追加中です<div class="loader--mini"></div>',
        });
        var params = new URLSearchParams();
        params.append("media_url", value);
        params.append("sns_type", "twitter");
        params.append("report_id", this.report_id);
        params.append("token", this.token);
        this.axios
          .post(addMediaAPI, params)
          .then((response) => {
            this.$message.closeAll();
            if (response.data.status === "OK") {
              this.reloadActiveTabLists();
              this.loadReportDetail();
              this.$alert("レポートの更新に1~2分程度時間がかかる場合があります。", "投稿を追加しました", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              });
            } else if (response.data.status == "NG") {
              this.$alert(`投稿データが${this.siteName} 上に存在しないため、レポートに追加できませんでした。`, "投稿データが取得できませんでした", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "error",
              });
            }
          })
          .catch(() => {
            this.$message.closeAll();
            this.$alert("時間を空けて再度お試しください。", "投稿の追加に失敗しました", {
              confirmButtonText: "OK",
              showCancelButton: false,
              type: "error",
            });
          });
      });
      this.attachPromptValidation(xPattern, promptClass);
    },
    addHashtag() {
      this.enter_on = true;
      if (this.edit.hashtag.length > 2 && this.edit.hashtagValue) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "ハッシュタグは最大3件までしか登録できません",
        });
      } else {
        let hashtagValue = this.edit.hashtagValue;
        if (hashtagValue) {
          this.edit.hashtag.push("#" + this.edit.hashtagValue);
        }
        this.edit.hashtagValue = "";
      }
      setTimeout(() => {
        this.enter_on = false;
      }, 200);
    },
    deleteHashtag(hashtag) {
      this.edit.hashtag.splice(this.edit.hashtag.indexOf(hashtag), 1);
    },
    addKeyword() {
      this.enter_on = true;
      if (this.edit.keyword.length > 2 && this.edit.keywordValue) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "キーワードは最大3件までしか登録できません",
        });
      } else {
        let keywordValue = this.edit.keywordValue;
        if (keywordValue) {
          this.edit.keyword.push(this.edit.keywordValue);
        }
        this.edit.keywordValue = "";
      }
      setTimeout(() => {
        this.enter_on = false;
      }, 200);
    },
    deleteKeyword(keyword) {
      this.edit.keyword.splice(this.edit.keyword.indexOf(keyword), 1);
    },
    settingOpen() {
      this.edit.report_name = this.report.summary.report_name.slice();
      this.edit.hashtag = this.report.summary.hashtag.slice();
      this.edit.keyword = this.report.summary.keyword.slice();
      this.setting_modal = true;
    },
    settingClose() {
      if (this.change_flag > 1) {
        this.$confirm("編集中の内容は保存されていません。", "設定画面を閉じてよろしいですか？", {
          confirmButtonText: "閉じる",
          cancelButtonText: "キャンセル",
          type: "warning",
        })
            .then(() => {
              this.setting_modal = false;
              this.change_flag = 0;
            })
            .catch(() => {});
      } else {
        this.setting_modal = false;
        this.change_flag = 0;
      }
    },
    openChangeReport() {
      this.change_report = true;
    },
    changeReportName(report_name) {
      this.report.summary.report_name = report_name;
    },
    changeReportSetting() {
      if (this.report_id == "demo") {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "デモではご利用いただけません",
        });
      } else {
        this.setting_loading = true;
        var params = new URLSearchParams();
        params.append("report_id", this.report_id);
        params.append("hashtag", JSON.stringify(this.edit.hashtag));
        params.append("mentiontag", JSON.stringify(this.edit.mentiontag));
        params.append("keyword", JSON.stringify(this.edit.keyword));
        params.append("token", this.token);
        this.axios.post(changeReportSettingAPI, params).then(() => {
          this.$router.push("/report");
          this.$alert("レポートの更新に1~2分程度時間がかかる場合があります。", "レポートの設定を変更しました", {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "success",
          });
        });
      }
    },
    loadQuery() {
      this.loading = true;
      this.scrollTop();
      this.report_id = this.$route.params.report_id;
      this.noinfluencer = false;
      this.report.summary = {};
      this.report.post = [];
      this.report.influencer = [];
      this.checkList = [];
      this.count = 0;
    },
    imgAdd(file, fileList) {
      this.file = file;
      this.fileList = fileList;
    },
    imgUpload() {
      var formData = new FormData();
      formData.append("file", this.file.raw);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      formData.append("type", "report");
      formData.append("report_id", this.report_id);
      formData.append("token", this.token);
      this.axios.post(ImgUploadAPI, formData, config).then((response) => {
        this.report.summary.img_url = response.data[0].img_url;
        this.file = "";
        this.fileList = [];
        this.img_change = false;
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "レポートイメージ画像を変更しました",
        });
      });
    },
    toSetting() {
      this.$router.push("/setting");
    },
    openInfluencer(account_name, sns_type) {
      this.openSeq += 1;
      this.detailLoading = true;
      this.influencer_drawer = true;
      document.documentElement.style.overflow = "hidden";

      const st = (sns_type || "").toString();
      this.influencer_view_key = `${st}:${account_name}:${this.report_id}:${this.openSeq}`;

      const nameMap = {
        instagram: "report_influencerDetailDrawer",
        tiktok: "report_tiktokerDetailDrawer",
        twitter: "report_twittererDetailDrawer",
      };

      const routeName = nameMap[st] || "report_influencerDetailDrawer";

      this.$router.push({
        name: routeName,
        params: {
          report_id: this.report_id,
          account_name: account_name,
          parent_component: "report",
          child: true,
        },
        query: { v: String(this.openSeq) },
      }).catch(() => {})
          .finally(() => { this.detailLoading = false; });
    },
    closeInfluencer() {
      this.influencer_drawer = false;
      this.detailLoading = false;
      document.documentElement.style.overflow = "auto";
      this.$router.push({
        name: "reportDetail",
        params: {
          report_id: this.report_id,
        },
      });
    },
    scrollTop() {
      window.scroll({
        //画面を上部に移動
        top: 0,
        behavior: "instant",
      });
    },
    syncMentiontag(value) {
      this.edit.mentiontag = value;
    },
    inquiry() {
      this.$intercom.show();
    },
    imgError(index) {
      this.report.influencer[index].profile_picture_url = this.s3BaseUrl + "/userdata/img_error.png";
    },
    exportReportDetail() {
      if (this.$store.state.permission.export.access) {
        this.export_dialog = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
    syncInfluencerList(snsType, value) {
      this.report[snsType].influencer_list = value;
    },
  },
  destroyed() {
    clearInterval(this.intervalId);
  },
  watch: {
    edit: {
      handler() {
        this.change_flag += 1;
      },
      deep: true,
    },
    $route(to) {
      if (to.name == "reportDetail" && !this.$route.params.backpage) {
        this.influencer_drawer = false;
      }
    },
    done_data() {
      this.count = 0;
      this.report.influencer = [];
    },
  },
  filters: {
    addComma(val) {
      if (isNaN(val)) {
        return val;
      } else {
        return Math.floor(val).toLocaleString();
      }
    },
    date(val) {
      const datetime_parse = val.replace(/-/g, "/");
      const date_after = datetime_parse.slice(0, -9);
      return date_after;
    },
    firstLetter(val) {
      return val.slice(0, 1);
    },
    lastUpadate(val) {
      const now = new Date();
      const lastUpdate = new Date(val);
      const diffSec = now.getTime() - lastUpdate.getTime();
      if (diffSec / (1000 * 60 * 60 * 24) > 1) {
        const diffDay = Math.floor(diffSec / (1000 * 60 * 60 * 24)) + "日前";
        return diffDay;
      } else if (diffSec / (1000 * 60 * 60) > 1) {
        const diffHour = Math.floor(diffSec / (1000 * 60 * 60)) + "時間前";
        return diffHour;
      } else {
        const diffTime = Math.floor(diffSec / (1000 * 60)) + "分前";
        return diffTime;
      }
    },
  },
};
</script>

<style>
.btn-try-infinite {
  color: aqua !important;
}

.loading-spiral {
  border: 2px solid #0095f6 !important;
  border-right-color: transparent !important;
  -webkit-animation: loading-rotating-data-v-46b20d22 linear 0.85s infinite !important;
}

.el-checkbox__label {
  display: none;
}

.report-tab-count-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
  color: #666;
}

.report-tab-count-item {
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
}

.report-tab-count-icon {
  margin-right: 5px;
}

/* タブ内のバッジ用スタイル */
.tab-badges {
  display: inline-flex;
  margin: -1px 0 0 0;
  vertical-align: middle;
}

.tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: bold;
  color: #fff;
  line-height: 1;
}

.tab-badge.b-post {
  background-color: #409eff;
}

.tab-badge.b-inf {
  background-color: #67c23a;
}
</style>
